import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import FrontPicture from "../picture/frontPicture";
import BackPicture from "../picture/backPicutre";

const verifiedDocuments = () => {
  return (
    <div className="main-verified-documents">
      <div className="title verified-documents">
        <div className="title">Verified Documents - Digant Bhatt</div>
      </div>
      <div className="user-detail-wrap">
        <Row>
          <Col lg={4}>
            <div className="user-detail">
              {" "}
              Name on Licence: <span>Digant Bhatt</span>
            </div>
          </Col>
          <Col lg={4}>
            <div className="user-detail">
              Date of Birth: <span>02/05/1972</span>
            </div>
          </Col>
          <Col lg={4}>
            <div className="user-detail">
              {" "}
              Licence number: <span>XXX-XXX-000</span>{" "}
            </div>
          </Col>
        </Row>
      </div>
      <div className="user-detail-wrap">
        <Row>
          <Col lg={4}>
            <div className="user-detail">
              {" "}
              Licence eexpired date: <span>02/2030</span>
            </div>
          </Col>
          <Col lg={8}>
            <div className="user-detail">
              Vehicle Class: <span>4 Wheel</span>
            </div>
          </Col>
        </Row>
      </div>

      <div className="driving-licence title">
        <div>Driving Licence</div>
      </div>

      <div className="picture-content d-flex justify-content-center align-items-center ">
        <Row>
          <Col lg={6}>
            <div className="front-picture"></div>
            <FrontPicture />
          </Col>
          <Col lg={6}>
            <div className="back-picture">
              <BackPicture />
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default verifiedDocuments;
